module.exports = __webpack_public_path__ + "img/vip_logo.70d3675e.png";